module.exports = __webpack_public_path__ + "static/media/icon-image.117a6d3e.svg";